var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-telegram",
    transform: "translate(-0.197 -0.099)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-telegram-plane",
    "data-name": "Icon awesome-telegram-plane",
    d: "M37.124,7.37l-5.618,26.5c-.424,1.87-1.529,2.335-3.1,1.454l-8.56-6.308-4.13,3.973a2.15,2.15,0,0,1-1.72.839l.615-8.718L30.476,10.77c.69-.615-.15-.956-1.072-.341L9.79,22.779,1.346,20.136c-1.837-.573-1.87-1.837.382-2.718L34.756,4.694c1.529-.573,2.867.341,2.369,2.676Z",
    transform: "translate(24.029 21.687)",
    fill: "#0d9648"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    transform: "translate(0.197 0.099)",
    fill: "none",
    stroke: "#0d9648",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42,
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTelegram);
export default __webpack_public_path__ + "static/media/ico-telegram.5cd28e44248909d8245c032aaad471d2.svg";
export { ForwardRef as ReactComponent };